export enum LoginSdkConfig {
  DEFAULT = "default",
  AD_PRICE = "ad_price_section",
  REQUEST_CALLBACK = "request_callback_section",
  EXPERT_REVIEW = "expert_review_section",
  EXCLUSIVE_VIDEO = "ncap_section",
  WISHLIST = "wishlist_section",
  CALCULATE_EMI = "emi_section",
  EXCLUSIVE_OFFER = "exclusive_section"
}